import React from 'react';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { UpsellModalVariations } from 'state/launchdarkly/variations';

import { IUpsellStrategyProps } from './types';
import { Upsell } from './upsell';
import { useFlavorFlowUpsell } from './use-flavorflow-upsell';
import { useMenuFeatureUpsell } from './use-menu-feature-upsell';

const MenuFeatureUpsell: React.FC<IUpsellStrategyProps> = props => {
  const upsellData = useMenuFeatureUpsell();

  return <Upsell {...upsellData} {...props} />;
};

const FlavorFlowUpsell: React.FC<IUpsellStrategyProps> = props => {
  const upsellData = useFlavorFlowUpsell();
  return <Upsell {...upsellData} {...props} />;
};

export const UpsellStrategy: React.FC<IUpsellStrategyProps> = props => {
  const enableSignupAfterCart = useFlag(LaunchDarklyFlag.ENABLE_MOVE_SIGNUP_AFTER_CART);
  const chefRecommendationEngine2 = useFlag(LaunchDarklyFlag.CHEF_RECOMMENDATION_ENGINE_2);
  const isChefEngineSanity = chefRecommendationEngine2?.toLowerCase() === 'sanity';
  const isFlavorFlowEngine = useFlag(LaunchDarklyFlag.ENABLE_FLAVOR_FLOW);
  const upsellModalVariation =
    useFlag<UpsellModalVariations>(LaunchDarklyFlag.UPSELL_MODAL) ?? UpsellModalVariations.NONE;

  const newUpsellUIEnabled =
    upsellModalVariation === UpsellModalVariations.CHECKOUT ||
    upsellModalVariation === UpsellModalVariations.MENU_AND_CHECKOUT;

  const shouldUseMenuFeatureUpsell = enableSignupAfterCart || isChefEngineSanity;

  if (shouldUseMenuFeatureUpsell) {
    return <MenuFeatureUpsell {...props} hasNewUpsellUI={newUpsellUIEnabled} />;
  }

  if (isFlavorFlowEngine) {
    return <FlavorFlowUpsell {...props} />;
  }

  return null;
};
